module.exports = __webpack_public_path__ + "img/BIRD SHADES PURPLE.2e82b58.svg";